import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import swal from 'swal';

import App from '@/App.vue';
import router from '@/js/router';
import $loading from '@/js/$loading';
import neCaptchaVerify from '@js/neCaptchaVerify';
import { isDevTool } from '@/../config/config';
import { vState, vApi, vMutations } from '@js/store.observable';

// mock 拦截ajax 模拟测试
// require('./js/mock');

// vue mixin
require('./js/vue-mixin');

Vue.use(neCaptchaVerify);
Vue.config.productionTip = !isDevTool;
Vue.prototype.$loading = $loading;
Vue.prototype.$qs = qs;

Vue.config.devtools = isDevTool;
Vue.prototype.swal = swal;
Vue.prototype.$axios = axios;
Vue.prototype.$store = { state: vState, method: vMutations, api: vApi };
Vue.prototype.$activity = window.activity;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
